import React, { Fragment, useState, useContext } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppContext } from "store/AppContext";
import { getKjosandiForElection } from 'common/services/apiService';


const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  },
  loadingWrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}));

export default function KennitalaStep(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const [kennitala, setKennitala] = useState('');
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const { setKjosandiInfo, handleNext, resetForm } = props;

  const handleChange = e => {
    setKennitala(e.target.value.replace(/\D/, ''));
  }

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      fetchKjosandiForElection();
    }
  }

  const validate = () => {
    if (kennitala === '') {
      setIsError(true);
      setErrorMsg('Nauðsynlegt er að slá inn kennitölu');
      return false;
    } else if (context.activeKosning.get.id === undefined) {
      setIsError(true);
      setErrorMsg('Engin kosning hefur verið valin');
      return false;
    }

    return true;
  }

  const fetchKjosandiForElection = async () => {
    if (!validate()) return;

    setLoading(true);
    
    const { data, httpStatus, isError } = await getKjosandiForElection(
      kennitala,
      context,
      {}
    );

    if (!isError) {
      setKjosandiInfo(data);
      resetForm();
      console.log(data)
      setLoading(false);
      handleNext();
    } else {
      if (httpStatus === 404) {
        setLoading(false);
        setIsError(true);
        setErrorMsg('Kennitala fannst ekki á kjörskrá fyrir kosninguna "' + context.activeKosning.get.lysing + '"');
      } else {
        setLoading(false);
        setIsError(true);
        setErrorMsg(`Óvænt villa kom upp`);
      }
    }
  }

  return (
    <Fragment>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justify="center"
        >
          <Grid item xs={12}>
            <Typography variant="h4">Kennitala kjósanda</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="input-kennitala"
              type="text"
              inputProps={{ maxLength: 10 }}
              label="Kennitala"
              value={kennitala}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              autoComplete="off"
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            {isError && (
              <div>
                <Typography color="error">{errorMsg}</Typography>
              </div>
            )}
          </Grid>
          <Grid item xs={12}>
            <div className={classes.loadingWrapper}>
              <Button
                color="primary"
                variant="contained"
                disabled={loading}
                onClick={fetchKjosandiForElection}
              >
                Áfram
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  );
}